import React from "react"
import { connect } from "react-redux"
import FlashMessage from "../components/flash-message"

const mapStateToProps = state => ({
  status: state.flash.status,
  text: state.flash.text
})

const mapDispatchToProps = dispatch => ({
  onClose: () => dispatch({type: "FLASH_CLEAR"})
})

export default connect(mapStateToProps, mapDispatchToProps)(FlashMessage)
